"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var Scroll =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Scroll, _React$Component);

  function Scroll() {
    var _this;

    (0, _classCallCheck2["default"])(this, Scroll);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Scroll).call(this));
    _this.state = {
      xLoc: 0,
      yLoc: 0
    };
    _this.setScrollLocs = _this.setScrollLocs.bind((0, _assertThisInitialized2["default"])(_this));
    _this.changeScrollPosition = _this.changeScrollPosition.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Scroll, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('scroll', this.setScrollLocs);
      this.setScrollLocs();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.setScrollLocs);
    }
  }, {
    key: "setScrollLocs",
    value: function setScrollLocs() {
      this.setState({
        xLoc: window.scrollX,
        yLoc: window.scrollY
      });
    }
  }, {
    key: "changeScrollPosition",
    value: function changeScrollPosition(x, y) {
      window.scrollTo(x, y);
      this.setScrollLocs();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          xLoc = _this$state.xLoc,
          yLoc = _this$state.yLoc;
      var children = this.props.children;
      return children({
        xLoc: xLoc,
        yLoc: yLoc,
        changeScrollPosition: this.changeScrollPosition
      });
    }
  }]);
  return Scroll;
}(_react["default"].Component);

exports["default"] = Scroll;